module.exports = __webpack_public_path__ + "static/img/logoIcon.fd885f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topBar1/logoIcon.png
// module id = jA92
// module chunks = 1